import { html } from 'lit';
/**
 * Semantic icon name → IcoMoon-Free glyph name mapping.
 * Append entries as the app demands new icons.
 */
const ICON_MAP = {
    grid: 'stack',
    building: 'office',
    camera: 'camera',
    users: 'users',
    user: 'user',
    gauge: 'meter',
    server: 'database',
    shield: 'shield',
    clock: 'clock',
    activity: 'stats-dots',
    list: 'list',
    cog: 'cog',
    card: 'credit-card',
    home: 'home',
    history: 'history',
    film: 'film',
    plus: 'plus',
    check: 'checkmark',
    arrow: 'arrow-right',
    lock: 'lock',
    play: 'play',
    eye: 'eye',
    warning: 'warning',
    info: 'info',
    bin: 'bin',
    pencil: 'pencil',
    download: 'download',
    calendar: 'calendar',
    location: 'location',
    key: 'key',
    power: 'power',
};
export const icon = (name, cls = 'text-[18px]') => html `<span class="jvi-${ICON_MAP[name] || name} ${cls}" aria-hidden="true"></span>`;
